// TODO I'm not sure we can test this code
export const download = (filename: string, fileContent: unknown): void => {
  const url = window.URL.createObjectURL(new Blob([fileContent as any]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
};
